'use es6';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { useThreadPresence } from '../hooks/useThreadPresence';
import ThreadPresenceAvatars from './ThreadPresenceAvatars';
import { hasAgentPresenceAccess } from 'conversations-thread-data/auth/public/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PresenceStyleWrapper = styled.div.withConfig({
  displayName: "ThreadPresence__PresenceStyleWrapper",
  componentId: "fsru11-0"
})(["align-items:center;display:flex;"]);
const ThreadPresence = ({
  threadId
}) => {
  const hasAccess = useSelector(hasAgentPresenceAccess);
  const {
    asyncPresentSenders
  } = useThreadPresence({
    threadId
  });
  return asyncPresentSenders.size && hasAccess ? /*#__PURE__*/_jsxs(PresenceStyleWrapper, {
    className: "ThreadPresence",
    children: [/*#__PURE__*/_jsx(ThreadPresenceAvatars, {
      asyncSenders: asyncPresentSenders
    }), /*#__PURE__*/_jsx(Small, {
      use: "help",
      className: "m-left-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.presence.viewingLabel"
      })
    })]
  }) : null;
};
ThreadPresence.displayName = 'ThreadPresence';
ThreadPresence.propTypes = {
  threadId: PropTypes.string.isRequired
};
export default ThreadPresence;